class PlaceNotFoundError extends Error {
    constructor(idOrSlug, error) {
        super(`${idOrSlug} does not exists`, error);
        this.name = 'PlaceNotFoundError';
    }
}
export default PlaceNotFoundError;
